
const BASE = 'http://jinri.sansg.com/php/'

export const getCommendProductsUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=75&language=en&num=9&commend=1`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=87&language=jp&num=9&commend=1`
  }

  return `${BASE}products.php?tid=63&num=9&commend=1`
}

export const getProductstypeUrl = lang => {
  if (lang === 'en') {
    return `${BASE}productstype.php?tid=75&language=en&num=6`
  }

  if (lang === 'ja') {
    return `${BASE}productstype.php?tid=87&language=jp&num=6`
  }

  return `${BASE}productstype.php?tid=63&num=6`
}
export const getProducttypeUrl = id => {
  return `${BASE}producttype.php?tid=${id}`
}
export const getProductsUrl = (lang, id) => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=${id}&language=en&num=100`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=${id}&language=jp&num=100`
  }

  return `${BASE}products.php?tid=${id}&num=100`
}
export const getProductUrl = id => {
  return `${BASE}product.php?pid=${id}`
}
export const getProductSwiperUrl = id => {
  return `${BASE}proimglist.php?pid=${id}`
}

export const getMediasUrl = id => {
  return `${BASE}news.php?newstype=${id}&num=100`
}
export const getMediaUrl = id => {
  return `${BASE}new.php?nid=${id}`
}

export const getHonorUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=81&language=en&num=100`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=93&language=jp&num=100`
  }

  return `${BASE}products.php?tid=69&num=100`
}

export const getMovieUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=86&language=en&num=100`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=98&language=jp&num=100`
  }

  return `${BASE}products.php?tid=74&num=100`
}

export const getHistoryArticleUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=83&language=en&num=100`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=95&language=jp&num=100`
  }

  return `${BASE}products.php?tid=71&num=100`
}
export const getHistoryUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=82&language=en&num=100`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=94&language=jp&num=100`
  }

  return `${BASE}products.php?tid=70&num=100`
}

export const getStaffUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=84&language=en&num=8`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=96&language=jp&num=8`
  }

  return `${BASE}products.php?tid=72&num=8`
}
export const getJobsUrl = lang => {
  if (lang === 'en') {
    return `${BASE}products.php?tid=85&language=en&num=8`
  }

  if (lang === 'ja') {
    return `${BASE}products.php?tid=97&language=jp&num=8`
  }

  return `${BASE}products.php?tid=73&num=8`
}

export const getSinglepageUrl = id => {
  return `${BASE}singlepage.php?id=${id}`
}

export const getCommendNewsUrl = lang => {
  if (lang === 'en') {
    return `${BASE}news.php?language=en&num=3&commend=1`
  }

  if (lang === 'ja') {
    return `${BASE}news.php?language=jp&num=3&commend=1`
  }

  return `${BASE}news.php?num=3&commend=1`
}

export const getCommendNewsUrlWithNewtype = (lang, id) => {
  if (lang === 'en') {
    return `${BASE}news.php?language=en&newstype=${id}&num=3&commend=1`
  }

  if (lang === 'ja') {
    return `${BASE}news.php?language=jp&newstype=${id}&num=3&commend=1`
  }

  return `${BASE}news.php?newstype=${id}&num=3&commend=1`
}
